module.exports = {
  Individual: 'Individual',
  AreYouWantToCopy: 'Are you sure you want to copy?',
  Hint: 'Prompt',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  BiDomainName: 'BI domain name',
  FillBiDomainName: 'Please fill in the BI domain name'
}
